(function() {
  if (sessionStorage.getItem('exitIntentShown')) return;

  var DELAY_MS = 30000; // 30s before enabling any trigger
  var SCROLL_DEPTH = 0.6; // 60% for mobile scroll trigger
  var popup = document.getElementById('exit-intent-popup');
  if (!popup) return;

  var triggered = false;
  var ready = false;

  function isCookieBannerVisible() {
    var banner = document.getElementById('shopify-pc');
    if (!banner) {
      // Also check by class in case ID differs
      banner = document.querySelector('.shopify-pc-banner');
    }
    if (!banner) return false;
    var style = window.getComputedStyle(banner);
    return style.display !== 'none' && style.visibility !== 'hidden' && banner.offsetHeight > 0;
  }

  function showPopup() {
    if (triggered) return;
    // Don't show if cookie banner is still visible — wait and retry
    if (isCookieBannerVisible()) {
      var observer = new MutationObserver(function(mutations, obs) {
        if (!isCookieBannerVisible()) {
          obs.disconnect();
          showPopup();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true, attributes: true });
      // Fallback: stop waiting after 60s
      setTimeout(function() { observer.disconnect(); }, 60000);
      return;
    }
    triggered = true;
    sessionStorage.setItem('exitIntentShown', '1');
    popup.hidden = false;
  }

  // Desktop: exit-intent (mouse leaves viewport top)
  function initDesktop() {
    document.addEventListener('mouseleave', function(e) {
      if (!ready || triggered || e.clientY > 20) return;
      showPopup();
    });
  }

  // Mobile: scroll depth trigger
  function initMobile() {
    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ready || triggered || ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        ticking = false;
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;
        if (docHeight > 0 && (scrollTop / docHeight) >= SCROLL_DEPTH) {
          showPopup();
        }
      });
    }, { passive: true });
  }

  // Initialize after delay
  setTimeout(function() {
    ready = true;
  }, DELAY_MS);

  if (window.innerWidth < 768) {
    initMobile();
  } else {
    initDesktop();
  }
})();
